import styled from "styled-components";
import HomepageTypeIcon from "./HomepageTypeIcon";
import __ from "../../utils/translator";

export default function HomepageCardTypologyTitle({
  typology
}) {
  return (
    <TypologyContainer>
      <StyledHomepageTypeIcon name={typology} />
      <TypeTitle>{__(typology)}</TypeTitle>
    </TypologyContainer>
  )
}

const TypologyContainer = styled.div`
  display: flex;
  gap: .25rem;
  align-items: center;
  color: #FFFFFF;
`;

const StyledHomepageTypeIcon = styled(HomepageTypeIcon)`
  color: #FFFFFF;
  height: 12px;
`;

const TypeTitle = styled.span`
  font-size: .8125rem;
  text-transform: uppercase;
  font-weight: bold;
  padding: .25rem 0 .25rem 0;
  font-family: 'Din-Medium', sans-serif;
`;
